import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TextState } from '../reducers/text.reducer';
import { TEXT_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<TextState>(TEXT_FEATURE_KEY);

export const selectText = (id: string) => createSelector(selectState, (state) => state.text[id]?.text ?? null);
export const selectLoading = (id: string) => createSelector(selectState, (state) => state.text[id]?.loading ?? null);
